import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { ServiceModel } from './service.model';

@Injectable({
  providedIn: 'root',
})
export class ServiceService extends AbstractEntityService<ServiceModel> {
  constructor(http: HttpClient) {
    super('/api/services', http);
  }
}
